import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  token: null,
  user: "",
  user_attr: "",
  user_type: "",
  id: "" || localStorage.getItem("user_id"),
  dataadmin_input: ""
  // project_des: {}
};

const mutations = {
  addusername(state, uname) {
    state.user = uname;
  },
  adduserAttr(state, attr) {
    state.user_attr = attr;
  },
  adduserType(state, type) {
    state.user_type = type;
  },
  set_dataadmin_input(state, val) {
    state.dataadmin_input = val;
  },
  adduserid(state, id) {
    state.id = id;
  }
};

const actions = {
  // 每次请求给header加上token
  addtoken(state, token) {
    state.state.token = token;
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/index.js